import { render, staticRenderFns } from "./complement-bandeau.vue?vue&type=template&id=572ecef0&scoped=true"
import script from "./complement-bandeau.vue?vue&type=script&lang=js"
export * from "./complement-bandeau.vue?vue&type=script&lang=js"
import style0 from "./complement-bandeau.vue?vue&type=style&index=0&id=572ecef0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572ecef0",
  null
  
)

export default component.exports